// Verwalten › Mein Tarif (h-ui): Was das eigene Radio laut Tarif darf und
// wie viel davon belegt ist. Ändern kann den Tarif nur der Betreiber.

import { useEffect, useState } from "react";
import { tarifApi } from "../api";
import { errorText } from "../components/streaming-ui";
import { Meldungen, Sym } from "../components/social-ui";
import { Badge, Callout, Card, Page, PageHeader, Skeleton } from "../components/ui";
import { Nutzungsbalken, STATUS_ANZEIGE, nutzungFuer, GRENZEN_FELDER } from "../components/hosting-ui";
import type { MeinTarif } from "../types";

export function MeinTarifPage(): JSX.Element {
  const [daten, setDaten] = useState<MeinTarif | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    tarifApi.meinTarif().then(setDaten).catch((err) => setFehler(errorText(err)));
  }, []);

  const ueber = daten?.ueber
    ? daten.ueber
    : daten
    ? GRENZEN_FELDER.filter((f) => {
        const g = daten.grenzen[f.key];
        if (typeof g !== "number") return false;
        const n = nutzungFuer(f.key, daten.nutzung).wert;
        return n != null && n > g;
      })
    : [];

  return (
    <Page className="max-w-4xl">
      <PageHeader
        eyebrow="Verwalten"
        title="Mein Tarif"
        description="Was euer Radio laut Tarif darf und wie viel davon belegt ist."
      />
      <Meldungen error={fehler} />

      {!daten && !fehler && <Skeleton className="h-80" />}

      {daten && (
        <>
          {daten.status !== "aktiv" && (
            <Callout tone={STATUS_ANZEIGE[daten.status]?.tone === "danger" ? "danger" : "warning"} className="mb-5" title={`Status: ${STATUS_ANZEIGE[daten.status]?.label ?? daten.status}`}>
              Bitte wendet euch an den Betreiber.
            </Callout>
          )}
          {ueber.length > 0 && (
            <Callout tone="warning" className="mb-5" title="Über der Grenze">
              Bestehendes bleibt erhalten, aber Neues geht erst wieder, wenn ihr aufräumt oder einen größeren Tarif bekommt.
            </Callout>
          )}
          <Card
            title={<span className="inline-flex items-center gap-2"><Sym name="sliders" className="h-4 w-4 text-muted" />Tarif „{daten.tarif.name}“</span>}
            description={daten.tarif.beschreibung ?? undefined}
            actions={<Badge tone="brand">{daten.tarif.key}</Badge>}
          >
            <Nutzungsbalken grenzen={daten.grenzen} nutzung={daten.nutzung} />
          </Card>
          <p className="mt-4 text-sm text-muted">
            Mehr Platz, mehr Kanäle oder Funktionen? Der Betreiber eurer Installation kann den Tarif erweitern
            oder einzelne Grenzen für euch anheben.
          </p>
        </>
      )}
    </Page>
  );
}
